import React from 'react';

import ReactDOM from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';  // Import BrowserRouter to manage routes

import './index.css';

import App from './App'; // Main app component

import reportWebVitals from './reportWebVitals';

 

// Wrap the app in BrowserRouter in index.js only

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

  <React.StrictMode>

    <BrowserRouter> {/* Router is applied only here */}

      <App />

    </BrowserRouter>

  </React.StrictMode>

);

 

reportWebVitals();

 
